import { gql } from '@apollo/client'

export default gql`
  mutation AcceptPrivacyAgreement {
    acceptPrivacyAgreement
  }
`;
